
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, UncontrolledTooltip } from 'reactstrap';
import RenderIcon from '../commons/RenderIcon';


const CollapsedMenuWithSIdebar = (props) => {

  const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      const listener = () => setMatches(media.matches);
      window.addEventListener("resize", listener);
      return () => window.removeEventListener("resize", listener);
    }, [matches, query]);

    return matches;
  };
  let menuItems = props.items;
  const { customIcons } = props
  const [hovered, setHovered] = useState(null);
  const [active, setActive] = useState(null);
  const [isClosedMenu, setIsCloseMenu] = useState(null);
  const [activeMenu, setActiveMenu] = useState({})
  const [activeChild, setActiveChild] = useState({});
  const [activeChildIndex, setActiveChildIndex] = useState(null)
  const [hoverChildIndex, setHoverChildIndex] = useState(null)
  const [animate, setAnimate] = useState(false);
  const changeSmall = useMediaQuery("(max-height: 550px)");
  const [hoverText, setHoverText] = useState('');
  let delay = 1;
  useEffect(() => {
    setAnimate(true);
    let timer = setTimeout(() => setAnimate(false), delay * 1000);

    return () => {
      clearTimeout(timer);
    };

  }, [active, delay]);
  useEffect(() => {
    props.toggleIsExpanded()

  }, []);

  const onClickMenuHandler = (item, index) => {
    setActive(index)
    setActiveMenu(item)
    console.log("Window", window)
    if (item && item.childMenus && item.childMenus.length !== 0) {
      window.storeExpand = true
    }
    else {
      window.storeExpand = false
    }
    console.log("Index", active, "menu", activeMenu)
    if (isClosedMenu === index) {
      setIsCloseMenu(null)
      props.toggleIsExpanded()
    }
    else {
      setIsCloseMenu(index)
      props.collapsewithsidebartoggleIsExpanded()
    }
    console.log("Closed", isClosedMenu)
    // if (item && item.childMenus && item.childMenus.length === 0) {
    //     window.location.href = `/app/${item.friendlyUrl.toLowerCase()}`;
    // }

  }
  const handleMouseEnter = (text, index) => {
    setHoverText(text);
    setHovered(index)
  };

  const handleMouseLeave = () => {
    setHoverText('');
    setHovered(null)
  };
  const handleChildMouseEnter = (index) => {
    setHoverChildIndex(index)
  };

  const handleChildMouseLeave = () => {
    setHoverChildIndex(null)
  };
  const childClickHandler = (child, index) => {
    setActiveChild(child)
    setActiveChildIndex(index)
  }


  return (
    <div className={`col_with_sidebar ${props.isExpanded && activeMenu.childMenus && activeMenu.childMenus.length !== 0 && "expanded"} collapse_with_sidebar`} >


      <div className='all-menu-icons'>
        {
          menuItems && menuItems.map((item, index) => {
            let parentItemProperties = item && item.properties ? item.properties : null
            if (parentItemProperties !== null) {
              var obj = JSON.parse(parentItemProperties);
              var parentItemIconObject = obj
            }
            const parentItemIcon = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.webMenuIcon ? parentItemIconObject.web.webMenuIcon : null
            const parentItemCustomIcon = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.customWebIcon ? parentItemIconObject.web.customWebIcon : null
            const parentItemCustomIconSize = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.webIconSize ? parentItemIconObject.web.webIconSize : null
            const iconConfig = {
              cssClass: !item.menuIcon  ? 'fa-joomla' : item.menuIcon,
              cssClass2: parentItemIcon,
              cssCustomIconMenu: parentItemCustomIcon,
              webIconSizeMenu: parentItemCustomIconSize // custom icon Size  
            }
            return <div


              className={`boxicon-container ${props.isExpanded && "expanded-boxicon-container  colla-with-side-main-div"
                } ${props.isExpanded && active === index ? "colla-with-side-main-div activeMenu" : "colla-with-side-main-div"}`}
              key={index}
              onClick={() => onClickMenuHandler(item, index)}
              onMouseEnter={() => handleMouseEnter(item.title, index)}
              onMouseLeave={handleMouseLeave}
            >{
                item && item.childMenus && item.childMenus.length === 0 ? <NavLink className="hoverMenuIcon" to={`/app/${item.friendlyUrl.toLowerCase()}`}>
                  <RenderIcon config={iconConfig} customIcons={customIcons} />
                  <p className={`${hoverText && hovered === index ? "collapse-hover" : 'mute-text'}`}>{hoverText && hovered === index ? hoverText : ''}</p>
                </NavLink>
                  :
                  <> <RenderIcon config={iconConfig} customIcons={customIcons} />


                    <p className={`${hoverText && hovered === index ? "collapse-hover" : 'mute-text'}`}>{hoverText && hovered === index ? hoverText : ''}</p>
                  </>
              }


            </div>



          })
        }
      </div >
      {
        props.isExpanded && activeMenu.childMenus && activeMenu.childMenus.length !== 0 &&
        <div className={'child_fixed_title_main_div'}>
          <ul className='child-second-container'>
            {/* {isClosedMenu && <p className={'child_fixed_title'}> {activeMenu.title}</p>} */}
            {
              activeMenu.childMenus.map((child, index) => {
                let parentItemProperties = child && child.properties ? child.properties : null
                if (parentItemProperties !== null) {
                  var obj = JSON.parse(parentItemProperties);
                  var parentItemIconObject = obj
                }
                const parentItemIcon = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.webMenuIcon ? parentItemIconObject.web.webMenuIcon : null
                const parentItemCustomIcon = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.customWebIcon ? parentItemIconObject.web.customWebIcon : null
                const parentItemCustomIconSize = parentItemIconObject && parentItemIconObject.web && parentItemIconObject.web.webIconSize ? parentItemIconObject.web.webIconSize : null
                const iconConfig = {
                  cssClass: child.menuIcon,  // for nenne-admin fontawesome icons
                  cssClass2: parentItemIcon,      // for diy-admin  fontawesome icons
                  cssCustomIconMenu: parentItemCustomIcon, // custom menu icons  
                  webIconSizeMenu: parentItemCustomIconSize // custom icon Size  
                }
                const path = `${props.baseWorkflowRoute}/${child.friendlyUrl.toLowerCase()}`;
                const childPath = `${path}`;
                return <NavLink key={index} to={childPath}>

                  <li className={`chid-main-div ${activeChildIndex === index ? 'activeChild' : ''}`} onClick={() => childClickHandler(child, index)}>

                    <RenderIcon config={iconConfig} customIcons={customIcons} />

                    <p className=''> {child.title}</p>

                  </li>
                </NavLink>

              })
            }
          </ul>
        </div>
      }

    </div>
  );
};

// const DesktopLevelTwoMenu = (props) => {
//   return <div className={`sidebarWithTopbar ${props.isExpanded && "expandedChildMenu"}`} >
//     {props.children}
//   </div>
// }

export default CollapsedMenuWithSIdebar;